/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React from 'react';

import { FormSectionGlobal as FormSection } from '@fitinsur/components'

import { Row } from "components/Grid";

import { GeneralSection } from '../../general/index';
import { FeePayableBySection } from '../index';

function RenderSection({
  disableAll,
  values,
  setFieldValue,
  errors,
  setFieldError,
  formikRef,
  idOperation,
  idOperationParent,
  idProduct,
  feePayableByGroup,
  setFeePayableByGroup,
  setGlobalQuestionnaire,
}) {

  return (
    <>
      <Row>
        <GeneralSection.components.Styled.Title>
          PAYABLE BY DETAILS
        </GeneralSection.components.Styled.Title>
      </Row>

      {feePayableByGroup.map((questions, index) => (
        <FormSection
          key={index}
          sectionIndex={index}
          sectionName="FEE_PAYABLE_BY"
          formikRef={formikRef}
          disableAll={disableAll}
          values={values}
          errors={errors}
          setFieldValue={setFieldValue}
          setFieldError={setFieldError}
          questionnaire={questions}
          setQuestionnaire={(questionnaire) => setFeePayableByGroup(feePayableByGroup.map((v, i) => i === index ? questionnaire : v))}
          idOperation={idOperation}
          idOperationParent={idOperationParent}
          idProduct={idProduct}
          permissions={true}
          onQuestionChange={(
            question,
            value,
            setFieldValue,
            questionnaireUpdated
          ) =>
            FeePayableBySection.events.handleQuestionChange({
              question,
              value,
              questionnaireUpdated,
              setQuestionnaireUpdated: (questionnaire) => setFeePayableByGroup(feePayableByGroup.map((v, i) => i === index ? questionnaire : v)),
              setFieldValue,
            })
          }
        />
      ))}
    </>
  )
}

const components = {
  RenderSection
}

export { components }